import store from '../store'
export default [
  {
    path: '/relatorios',
    name: 'relatorios-index',
    beforeEnter: async (to, from, next) => {
      await store.commit('resetVariaveis')
      next()
    },
    meta: {
      title: 'Relatórios',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/relatorio')
    }
  }
]
